import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons";
import { faCheckCircle, faCircleXmark, faCoins, faFileSignature, faTicket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

const Payment = (props) => {
    const { t } = useTranslation();
    const { p } = props;

    return (
        <Fragment>
            <tr>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faFileSignature} className="me-1 me-lg-2" />
                    {p.order_number}
                </td>

                <td className={`border-bottom-0 pb-0`}>
                    <FontAwesomeIcon icon={faTicket} className="me-1 me-lg-2" />
                    {p.pass_name}
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faFileSignature} className="me-1 me-lg-2" />
                    {p.payment_type_name}
                </td>
                <td className={`border-bottom-0 pb-0`}>
                    <FontAwesomeIcon icon={faCalendarCheck} className="me-1 me-lg-2" />
                    {moment(p.create_date).format("YYYY-MM-DD HH:mm:ss")}
                </td>
            </tr>
            <tr>
                <td className="">
                    <FontAwesomeIcon icon={faCoins} className="me-1 me-lg-2" />
                    {p.up_price.toFixed(2).toString().replace(".", ",")} {t("currency")}
                </td>
                <td className="">
                    {p.payment_status_code === "PAID" ? (
                        <span className="text-success">
                            <FontAwesomeIcon icon={faCheckCircle} className="me-1 me-lg-2" />
                            {t(`payments.${p.payment_status_code}`)}
                        </span>
                    ) : (
                        <span className="text-danger">
                            <FontAwesomeIcon icon={faCircleXmark} className="me-1 me-lg-2" />
                            {t(`payments.${p.payment_status_code}`)}
                        </span>
                    )}
                </td>
            </tr>
        </Fragment>
    );
};

export default Payment;
